/**
 * Cloudinary URL optimizer — inserts f_auto,q_auto,w_{width} transformation
 * so we never serve a 3840×2160 original when a 300px thumbnail is needed.
 *
 * Usage:
 *   cloudinaryOptimize(url, 800)  → full-width card image
 *   cloudinaryOptimize(url, 400)  → thumbnail
 *   cloudinaryOptimize(url, 96)   → tiny avatar
 */
export const cloudinaryOptimize = (url, width = 800) => {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  // Already has transformations — replace width only
  if (url.includes('/upload/f_auto')) {
    return url.replace(/\/upload\/[^/]+\//, `/upload/f_auto,q_auto,w_${width}/`);
  }
  return url.replace('/upload/', `/upload/f_auto,q_auto,w_${width}/`);
};
